module.exports = __webpack_public_path__ + "img/71f00040001b001.asm.22be17dd.jpg";